import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import Payments from '../Payments/Payments';

const SelectProctor = observer(class SelectProctor extends React.Component {
  render() {
    const { translation } = this.props;

    return(
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>

        <div className="slide-wrap wrap">
          <div className={`panel panel--brief`}>
            <h2 className="panel__title">{translation.payment_form}</h2>

            <Payments {...this.props} />
          </div>
        </div>
      </div>
    )
  }
})

export default translate('SelectProctor')(SelectProctor);


// WEBPACK FOOTER //
// ./src/app/components/LocateProctor/SelectProctor.js